import { createFileRoute } from "@tanstack/react-router";

import { calendarEventSearchParamsSchema } from "@/domain/event";
import { CalendarsScreen } from "@/interactors/CalendarsScreen";
import { headWithCustomTitle, validateRoutePermission } from "@/utils/router";

export const Route = createFileRoute("/_authed/admin/calendars/")({
  component: CalendarsScreen,

  beforeLoad: ({ context }) =>
    validateRoutePermission({
      context,
      action: "read",
      subject: "events",
    }),
  head: () => headWithCustomTitle("main:calendars.title"),
  validateSearch: calendarEventSearchParamsSchema,
});
